<template>
  <div class="content">
    <card class="text-left">
      <div class="row" v-if="id !== null">
        <label class="col-sm-2 col-form-label">챌린지 ID</label>
        <div class="col-sm-3">
          <base-input>
            <p class="form-control-static">{{ id }}</p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">제목</label>
        <div class="col-sm-10">
          <base-input placeholder="타이틀" v-model="title">
            <span slot="helpBlock" class="form-text" />
          </base-input>
        </div>
        <label class="col-sm-2 col-form-label">경로</label>
        <div class="col-sm-10">
          <base-input placeholder="경로" v-model="path">
            <span slot="helpBlock" class="form-text" />
          </base-input>
        </div>
        <label class="col-sm-2 col-form-label">한국어 타이틀 </label>
        <div class="col-sm-10">
          <base-input placeholder="타이틀" v-model="titleKo">
            <span slot="helpBlock" class="form-text" />
          </base-input>
        </div>
        <label class="col-sm-2 col-form-label">영어 타이틀 </label>
        <div class="col-sm-10">
          <base-input placeholder="타이틀" v-model="titleEn">
            <span slot="helpBlock" class="form-text" />
          </base-input>
        </div>
        <label class="col-sm-2 col-form-label">일본어 타이틀 </label>
        <div class="col-sm-10">
          <base-input placeholder="타이틀" v-model="titleJa">
            <span slot="helpBlock" class="form-text" />
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">내용 ( 한 / 영 / 일 )</label>
        <div class="col-sm-10">
          <div class="row">
            <div class="col-sm-4">
              <textarea class="form-control" id="content" rows="30" v-model="bodyKo" />
            </div>
            <div class="col-sm-4">
              <textarea class="form-control" id="content" rows="30" v-model="bodyEn" />
            </div>
            <div class="col-sm-4">
              <textarea class="form-control" id="content" rows="30" v-model="bodyJa" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">챌린지 DAY</label>
        <div class="col-sm-10">
          <base-input placeholder="챌린지 DAY" v-model="goal">
            <span slot="helpBlock" class="form-text" />
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">이미지 ( 한 / 영 / 일 )</label>
        <div class="col-sm-10">
          <div class="row">
            <div class="col-sm-4">
              <BlipFileUploadZone :upload-category="10" :maxFiles="1" :fileUrl="imageFileId | blipImageUrl" @onChangeFileIds="onFileIdChange" />
            </div>
            <div class="col-sm-4">
              <BlipFileUploadZone :upload-category="10" :maxFiles="1" :fileUrl="imageEnFileId | blipImageUrl" @onChangeFileIds="onFileEnIdChange" />
            </div>
            <div class="col-sm-4">
              <BlipFileUploadZone :upload-category="10" :maxFiles="1" :fileUrl="imageJaFileId | blipImageUrl" @onChangeFileIds="onFileJaIdChange" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">첨부 ( 한 / 영 / 일 )</label>
        <div class="col-sm-10">
          <base-button @click="addField" type="success">+</base-button><base-button @click="deleteField" type="success">-</base-button>

          <draggable class="row" handle=".handle" v-model="metadata" @start="drag = true" @end="drag = false">
            <div v-for="(field, index) in metadata" class="handle col-sm-12">
              <div class="row">
                <div class="col-sm-4">
                  <BlipFileUploadZone
                    :upload-category="10"
                    :maxFiles="1"
                    :fileUrl="field.imageFileId | blipImageUrl"
                    @onChangeFileIds="onImageFileIdsChange($event, index)"
                  />
                </div>
                <div class="col-sm-4">
                  <BlipFileUploadZone
                    :upload-category="10"
                    :maxFiles="1"
                    :fileUrl="field.imageEnFileId | blipImageUrl"
                    @onChangeFileIds="onImageEnFileIdsChange($event, index)"
                  />
                </div>
                <div class="col-sm-4">
                  <BlipFileUploadZone
                    :upload-category="10"
                    :maxFiles="1"
                    :fileUrl="field.imageJaFileId | blipImageUrl"
                    @onChangeFileIds="onImageJaFileIdsChange($event, index)"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <textarea class="form-control" id="content" rows="3" v-model="field.text"></textarea>
                </div>
                <div class="col-sm-4">
                  <textarea class="form-control" id="content" rows="3" v-model="field.textEn"></textarea>
                </div>
                <div class="col-sm-4">
                  <textarea class="form-control" id="content" rows="3" v-model="field.textJa"></textarea>
                </div>
              </div>
            </div>
          </draggable>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">해시태그</label>
        <div class="col-sm-10">
          <base-input placeholder="해시태그" v-model="hashTag">
            <span slot="helpBlock" class="form-text" />
          </base-input>
        </div>
      </div>
    </card>
    <base-button class="update-button col-sm-3" @click.prevent="save()" type="confirm">저장</base-button>
    <base-button v-if="id !== null" class="delete-button col-sm-3" @click.prevent="deleteChallenge()" type="confirm">삭제</base-button>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import swal from "sweetalert2";
import BlipFileUploadZone from "../../components/BlipFileUploadZone.vue";
import draggable from "vuedraggable";
import { Toast } from "@/util/Toast";

export default {
  components: {
    draggable,
    BlipFileUploadZone,
    BaseInput,
    Card,
  },
  async created() {
    if (this.$route.query.id) {
      this.id = Number(this.$route.query.id);
      await this.getChallengeDetail();
    }
  },
  data() {
    return {
      id: null,
      path: null,
      imageFileId: null,
      imageEnFileId: null,
      imageJaFileId: null,
      imageFileUrl: null,
      imageEnFileUrl: null,
      imageJaFileUrl: null,
      title: null,
      titleKo: null,
      titleEn: null,
      titleJa: null,
      bodyKo: null,
      bodyEn: null,
      bodyJa: null,
      type: null,
      metadata: [],
      goal: null,
      hashTag: null,
    };
  },

  methods: {
    addField() {
      this.metadata.push({ imageFileId: null, imageEnFileId: null, imageJaFileId: null, text: null, textEn: null, textJa: null });
    },
    deleteField() {
      this.metadata.splice(this.metadata.length - 1, 1);
      this.$forceUpdate();
    },
    onImageFileIdsChange(newFileIds, index) {
      this.metadata[index].imageFileId = newFileIds[0];
    },
    onImageEnFileIdsChange(newFileIds, index) {
      this.metadata[index].imageEnFileId = newFileIds[0];
    },
    onImageJaFileIdsChange(newFileIds, index) {
      this.metadata[index].imageJaFileId = newFileIds[0];
    },
    async getChallengeDetail() {
      await this.$axios.get(`/fanLogs/challenges/${this.id}`).then((res) => {
        const data = res.data.data;
        this.hashTag = data.hashTag;
        this.goal = data.goal;
        const titles = JSON.parse(data.titles);
        this.titleKo = _.find(titles, { code: "ko" })?.text;
        this.titleEn = _.find(titles, { code: "en" })?.text;
        this.titleJa = _.find(titles, { code: "ja" })?.text;
        const imageFileIds = JSON.parse(data.imageFileIds);
        console.log(imageFileIds);
        this.imageFileId = _.find(imageFileIds, { code: "ko" })?.imageFileId;
        this.imageEnFileId = _.find(imageFileIds, { code: "en" })?.imageFileId;
        this.imageJaFileId = _.find(imageFileIds, { code: "ja" })?.imageFileId;
        const bodies = JSON.parse(data.bodies);
        this.bodyKo = _.find(bodies, { code: "ko" })?.text;
        this.bodyEn = _.find(bodies, { code: "en" })?.text;
        this.bodyJa = _.find(bodies, { code: "ja" })?.text;
        this.metadata = JSON.parse(data.metadata);
        this.path = data.path;
        this.title = data.title;
      });
    },

    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },
    onFileEnIdChange(newFileIds) {
      this.imageEnFileId = newFileIds[0];
    },

    onFileJaIdChange(newFileIds) {
      this.imageJaFileId = newFileIds[0];
    },

    async save() {
      const pathRegex = /^[a-zA-Z0-9_]+$/;
      if (!pathRegex.test(this.path)) {
        Toast.error("공백과 특수문자를 제외하고 영문과 숫자, _만 입력해 주세요");
        return;
      }
      if (this.metadata.length > 1 && this.metadata.length !== parseInt(this.goal, 10)) {
        Toast.error("첨부한 카운트가 맞지 않습니다");
        return;
      }
      const titles = [
        { code: "ko", text: this.titleKo },
        { code: "en", text: this.titleEn },
        { code: "ja", text: this.titleJa },
      ];
      const bodies = [
        { code: "ko", text: this.bodyKo },
        { code: "en", text: this.bodyEn },
        { code: "ja", text: this.bodyJa },
      ];

      const imageFileIds = [
        { code: "ko", imageFileId: this.imageFileId },
        { code: "en", imageFileId: this.imageEnFileId },
        { code: "ja", imageFileId: this.imageJaFileId },
      ];

      const params = {
        title: this.title,
        path: this.path,
        hashTag: this.hashTag,
        goal: this.goal,
        titles: JSON.stringify(titles),
        bodies: JSON.stringify(bodies),
        imageFileIds: JSON.stringify(imageFileIds),
        metadata: JSON.stringify(this.metadata),
      };
      if (this.id) {
        await this.$axios.put(`/fanLogs/challenges/${this.id}`, { params }).then((res) => {
          Toast.success("수정 되었습니다");
        });
      } else {
        await this.$axios.post(`/fanLogs/challenges`, { params }).then((res) => {
          Toast.success("등록 되었습니다");
        });
      }
      history.go(-1);
    },

    async deleteChallenge() {
      swal
        .fire({
          title: "삭제 확인",
          text: `${this.id} 챌린지 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios.delete(`/fanLogs/challenges/${this.id}`).then((res) => {
                Toast.success("챌린지가 삭제 되었습니다");
                history.go(-1);
              });
            } catch (err) {
              Toast.error("챌린지 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
.actions {
  margin-bottom: 40px;
}
.pointer {
  cursor: pointer;
}
</style>
